import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import Typography from '@mui/material/Typography'
import { PLAN_USAGE } from '../planUsageDesignTokens'

export function PlanUsageActivityHeatmapLegend() {
  return (
    <Stack
      direction="row"
      justifyContent="space-between"
      alignItems="center"
      sx={{ px: 2, flexWrap: 'wrap', gap: 1.25 }}
    >
      <Typography sx={{ fontSize: '0.75rem', fontWeight: 510, lineHeight: '30px', color: PLAN_USAGE.footerMuted }}>
        2023 Sunday first
      </Typography>
      <Stack direction="row" alignItems="center" spacing={1.25} aria-label="Heatmap legend">
        <Typography sx={{ fontSize: '0.875rem', fontWeight: 510, lineHeight: '30px', color: PLAN_USAGE.monthAxis }}>
          Less
        </Typography>
        <Box sx={{ width: 20, height: 20, borderRadius: '4px', bgcolor: PLAN_USAGE.heatEmpty }} />
        <Box sx={{ width: 20, height: 20, borderRadius: '4px', bgcolor: PLAN_USAGE.heatLow }} />
        <Box sx={{ width: 20, height: 20, borderRadius: '4px', bgcolor: PLAN_USAGE.heatMid }} />
        <Box sx={{ width: 20, height: 20, borderRadius: '4px', bgcolor: PLAN_USAGE.heatHigh }} />
        <Typography sx={{ fontSize: '0.875rem', fontWeight: 510, lineHeight: '30px', color: PLAN_USAGE.monthAxis }}>
          More
        </Typography>
      </Stack>
    </Stack>
  )
}
